import { reportingPeriodsImplyingFiscalYear } from '../constants';
import { getReportingPeriodLabel, getStatementTypeLabel } from './config';

export const toTitleCase = (text: string) =>
  text
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const getSankeyTitle = ({
  company_name,
  custom_title,
  fiscal_year,
  reporting_period,
  statement_type,
  use_custom_title,
}: Pick<
  SankeyFormValues,
  | 'company_name'
  | 'custom_title'
  | 'fiscal_year'
  | 'reporting_period'
  | 'statement_type'
  | 'use_custom_title'
>) => {
  if (use_custom_title && custom_title) {
    return custom_title;
  } else {
    const period =
      reporting_period !== 'full_year'
        ? ` ${getReportingPeriodLabel(reporting_period)}`
        : '';
    const year = reportingPeriodsImplyingFiscalYear.includes(reporting_period)
      ? ` FY${fiscal_year.toString().slice(-2)}`
      : ` ${fiscal_year}`;
    const type =
      statement_type && statement_type !== 'null' && statement_type !== 'other'
        ? ` ${toTitleCase(getStatementTypeLabel(statement_type))}`
        : '';
    return `${company_name}${period}${year}${type}`;
  }
};
